import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_whatsapp.svg'


const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "justify-center items-center flex overflow-hidden fixed inset-0 z-60 outline-none focus:outline-none" }
const _hoisted_3 = {
  class: "relative",
  style: {"width":"700px"}
}
const _hoisted_4 = { class: "rounded-xl xxl:rounded-2xl shadow-lg p-6 relative flex flex-col bg-white outline-none focus:outline-none" }
const _hoisted_5 = { class: "absolute right-0 top-0 pr-2 pt-2" }
const _hoisted_6 = { class: "inline-flex justify-center" }
const _hoisted_7 = { class: "popup-message text-center pt-2" }
const _hoisted_8 = {
  key: 0,
  class: "font-semibold text-gray-lp-300 mb-2 text-16px xxl:text-16px text-center"
}
const _hoisted_9 = {
  key: 1,
  class: "font-semibold text-gray-lp-300 mb-2 text-16px xxl:text-16px text-center"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Kendala sudah dilaporkan, ")
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("tapi belum terdaftar di kategori kendala Genesis. ")
const _hoisted_13 = { class: "flex flex-row w-full text-center rounded-xl border border-gray-lp-1600 p-2.5" }
const _hoisted_14 = { class: "flex flex-col w-1/3 gap-1 pr-2.5 border-r border-gray-lp-1600" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-lp-800" }, "No. kendala", -1)
const _hoisted_16 = { class: "flex flex-row justify-center gap-1" }
const _hoisted_17 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_18 = { class: "flex flex-col w-1/3 gap-1 px-2.5 border-r border-gray-lp-1600" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-lp-800" }, "No STT / shipment id", -1)
const _hoisted_20 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_21 = { class: "flex flex-col w-1/3 gap-1 pl-2.5" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-lp-800" }, "Kategori kendala", -1)
const _hoisted_23 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_24 = { class: "flex flex-col bg-blue-lp-600 rounded-md mt-6 items-center px-2 py-1.5" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-row text-sm text-blue-lp-500 items-center"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Khusus informasi klaim Anda bisa melacak  ")
const _hoisted_27 = /*#__PURE__*/_createVNode("a", {
  href: "https://lionparcel.com/klaim/track",
  target: "_blank",
  class: "font-bold underline"
}, "di sini", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_29 = { class: "flex flex-col text-sm text-blue-lp-500 w-full items-center" }
const _hoisted_30 = { class: "inline-flex items-center" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Hubungi CS untuk melaporkan kendala baru ")
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createTextVNode("Telepon:  "),
  /*#__PURE__*/_createVNode("a", {
    href: "tel:+622180820072",
    target: "_blank",
    class: "font-bold underline"
  }, "+62-21-80820072"),
  /*#__PURE__*/_createTextVNode("  |   "),
  /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center gap-x-1" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      width: "17",
      height: "17"
    }),
    /*#__PURE__*/_createVNode("a", {
      class: "underline target-blank font-bold",
      target: "_blank",
      href: "https://wa.me/6281119561000"
    }, "+62811-1956-1000")
  ])
], -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-50 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("img", {
              src: require(`@/app/ui/assets/svg/x-gray-24.svg`),
              class: "w-6 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forceCloseDialog && _ctx.forceCloseDialog(...args))),
              alt: "close"
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", null, [
              _createVNode("img", {
                src: require(`@/app/ui/assets/svg/badge-exit-confirmation.svg`),
                alt: "",
                class: "w-32 h-32"
              }, null, 8, ["src"])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            (_ctx.isEligibleCategory)
              ? (_openBlock(), _createBlock("div", _hoisted_8, " Kendala sudah dilaporkan, sebelum pusat resolusi terbaru. "))
              : (_openBlock(), _createBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12
                ]))
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.modelValue.caseNumber), 1),
                _createVNode("div", {
                  class: ["text-xs font-medium rounded-2xl px-2 text-center content-center", _ctx.mapStatusTicket.style]
                }, _toDisplayString(_ctx.mapStatusTicket.label), 3)
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("div", _hoisted_20, _toDisplayString(_ctx.modelValue.refNo), 1)
            ]),
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.modelValue.categoryName), 1)
            ])
          ]),
          _createVNode("div", _hoisted_24, [
            (_ctx.isClaimInformation)
              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                  _createVNode("img", {
                    src: require(`@/app/ui/assets/svg/ics_f_info_circle_blue.svg`),
                    alt: "",
                    class: "w-6 h-6 mr-1"
                  }, null, 8, ["src"]),
                  _hoisted_26,
                  _hoisted_27,
                  _hoisted_28
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                (_ctx.isCsInformation)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: require(`@/app/ui/assets/svg/ics_f_info_circle_blue.svg`),
                      alt: "",
                      class: "w-6 h-6 mr-1"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                _hoisted_31
              ]),
              _hoisted_32
            ])
          ])
        ])
      ])
    ]),
    _hoisted_33
  ]))
}